export var SUPPORTED_LOCALES_TUPLE = ['en', 'fr', 'de', 'es'];
export var SUPPORTED_LOCALES = ['en', 'fr', 'de', 'es'];
export var DEFAULT_LOCALE = 'en';
export var LONG_FORM_LOCALES = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
};
export var URL_SEGMENT_LOCALES = {
    en: '',
    es: '/es',
    fr: '/fr',
    de: '/de',
};
